import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Box } from '@cowsquare/design';
import { Title } from './Title';
import { HTMLContent } from './HTMLContent';

const Info = styled(Box)`
  display: inline-block;
  font-size: ${themeGet('fontSizes.text')};
  color: ${themeGet('colors.blacks.6')};
`;

export const ArticleContent = ({ title, info, content }) => (
  <Box px={[5, 0]} py={8}>
    <Title mb={4}>{title}</Title>
    <Info mb={6}>{info}</Info>
    <HTMLContent html={content} />
  </Box>
);
